export default function alertBanners() {
	var banners = document.querySelectorAll('.alert-banner')

	banners.forEach(banner => {
		var bannerId = ''
		for (var i = 0; i < banner.classList.length; i++) {
			bannerId += banner.classList[i]
		}

		if (sessionStorage['closedAlerts'] && JSON.parse(sessionStorage['closedAlerts']).indexOf(bannerId) !== -1) {
			banner.style.display = 'none'
        }
        
        var closeButton = banner.querySelector('.alert-banner__close');

        if (closeButton) {
            closeButton.addEventListener('click', () => {
                var h = banner.getBoundingClientRect().height
    
                banner.style.height = h + 'px'
                banner.style.transition = 'all 450ms ease 0s'
    
                setTimeout(() => {
                    banner.style.height = '0px'
                    banner.style.padding = '0px'
    
                    if (sessionStorage['closedAlerts']) {
                        sessionStorage['closedAlerts'] = JSON.stringify(JSON.parse(sessionStorage['closedAlerts']).push(bannerId))
                    } else {
                        sessionStorage['closedAlerts'] = JSON.stringify([bannerId])
                    }
                }, 0)
            })
        }
		
	})
}